export default {
    GET_PERSONAL_PICKUPS_REQUEST: state => {
        state.personalPickupsLoading = true
    },
    GET_PERSONAL_PICKUPS_SUCCESS: (state, data) => {
        state.personalPickups = data.results
        state.personalPickupsLoading = false
    },
    GET_PERSONAL_PICKUPS_FAILURE: state => {
        state.personalPickupsLoading = false
    },
    GET_PERSONAL_PICKUPS_ORDERS_REQUEST: state => {
        state.personalPickupsOrdersLoading = true
    },
    GET_PERSONAL_PICKUPS_ORDERS_SUCCESS: (state, data) => {
        state.personalPickupsOrders = data.results
        state.personalPickupsOrdersLoading = false
    },
    GET_PERSONAL_PICKUPS_ORDERS_FAILURE: state => {
        state.personalPickupsOrdersLoading = false
    },
    SET_PERSONAL_PICKUPS_ORDERS_FILTERS: (state, filters) => {
        state.filters = filters
    },
    CLEAR_PERSONAL_PICKUPS_ORDERS_FILTERS: state => {
        state.filters = state.setInitialFilters()
    }
}
